<template>
  <b-navbar-nav class="ml-auto">
    <b-nav-item href="#"><em>{{ currentUser.nickname }}</em></b-nav-item>
    <b-avatar :src="currentUser.avatarUrl"></b-avatar>
    <b-button class="mx-3" variant="outline-light" @click="signOut">
      <strong>Sign Out</strong>
    </b-button>
  </b-navbar-nav>
</template>

<script>
import { Auth } from "aws-amplify";
import { mapState } from "vuex";
export default {
  name: "UserProfile",
  computed: {
    ...mapState('auth', ['currentUser'])
  },
  methods: {
    async signOut() {
      try {
        sessionStorage.clear();
        await Auth.signOut();
        await this.$router.replace('/auth')
      } catch (error) {
        console.log('error:', error)
      }
    }
  }
}
</script>

<style scoped>

</style>
